// проверяем авторизацию и возвращаем header для авторизации
export function authHeader() {
    let token = localStorage.getItem('auth_token');
    return (token) ? {'Authorization': 'Bearer ' + token} : {}
}
